<template>
  <div class="user-input-block">
    <h3 class="user-input-block__title">
      {{ $t("view.flow.block.input.userInput") }}
    </h3>
    <div class="user-input-block__wrapper">
      <div class="user-input-block__memory-data">
        <sel
          @input="onInput"
          class="user-input-block__input"
          v-model="val.storage"
          :label="$t('view.flow.block.data.groupStorage')"
        >
          <option value="database">{{ $t("common.database") }}</option>
          <option value="cache">{{ $t("common.cache") }}</option>
          <option value="context">{{ $t("common.context") }}</option>
        </sel>
        <sel
          @input="onInput"
          class="user-input-block__input"
          v-model="val.type"
          :label="$t('view.flow.block.input.inputType')"
        >
          <option value="text">
            {{ $t("view.flow.block.input.inputTypeText") }}
          </option>
          <option value="number">
            {{ $t("view.flow.block.input.inputTypeNumber") }}
          </option>
          <option value="float">
            {{ $t("view.flow.block.input.inputTypeFloat") }}
          </option>
          <option value="phone">
            {{ $t("view.flow.block.input.inputTypePhone") }}
          </option>
          <option value="email">
            {{ $t("view.flow.block.input.inputTypeEmail") }}
          </option>
          <option value="date">
            {{ $t("view.flow.block.input.inputTypeDate") }}
          </option>
          <option value="time">
            {{ $t("view.flow.block.input.inputTypeTime") }}
          </option>
          <option value="regex">
            {{ $t("view.flow.block.input.inputTypeRegex") }}
          </option>
          <option value="image">
            {{ $t("view.flow.block.input.inputTypeImage") }}
          </option>
          <option value="video">
            {{ $t("view.flow.block.input.inputTypeVideo") }}
          </option>
          <option value="media">
            {{ $t("view.flow.block.input.inputTypeMedia") }}
          </option>
        </sel>
        <in
          @input="onInput"
          class="user-input-block__input"
          v-model="val.name"
          :label="$t('view.flow.block.input.keyName')"
        ></in>
        <in
          @input="onInput"
          type="number"
          v-show="
            val.type === 'text' || val.type === 'number' || val.type === 'float'
          "
          class="user-input-block__input user-input-block__input--short"
          v-model="val.additionalFilters.min"
          :label="$t('common.min')"
        ></in>
        <in
          @input="onInput"
          type="number"
          v-show="
            val.type === 'text' || val.type === 'number' || val.type === 'float'
          "
          class="user-input-block__input user-input-block__input--short"
          v-model="val.additionalFilters.max"
          :label="$t('common.max')"
        ></in>
      </div>
      <div class="user-input-block__regex-data">
        <in
          @input="onInput"
          v-show="val.type === 'regex'"
          class="user-input-block__input user-input-block__input--long"
          v-model="val.additionalFilters.regexPattern"
          :label="$t('view.flow.block.input.regexPattern')"
        ></in>
        <in
          @input="onInput"
          v-show="val.type === 'regex'"
          class="user-input-block__input"
          v-model="val.additionalFilters.regexFlags"
          :label="$t('view.flow.block.input.regexFlags')"
        ></in>
      </div>
      <div class="user-input-block__message-data">
        <label class="user-input-block__label">
          {{ $t("view.flow.block.input.incorrectInputMessageLabel") }}
          <br />
          <textarea-autosize
            class="user-input-block__textarea"
            v-model="val.incorrectInputMessage.text"
            ref="textarea"
            maxlength="640"
            @input.native="onInput"
            rows="4"
          ></textarea-autosize>
        </label>
        <div class="user-input-block__buttons-inputs">
          <in
            @input="onInput"
            class="user-input-block__button-input"
            v-model="val.incorrectInputMessage.cancelButton"
            :label="$t('view.flow.block.input.cancelButtonTitle')"
          ></in>
          <sel
            @input="onInput"
            class="user-input-block__button-input"
            v-model="val.incorrectInputMessage.cancelTarget"
            :label="$t('view.flow.block.input.cancelButtonTarget')"
          >
            <optgroup
              v-for="group in $store.state.flowGroups"
              :key="group.id"
              :label="group.name"
            >
              <option
                v-for="block in group.blocks"
                :key="block.id"
                :value="block.uuid"
              >
                {{ block.name }}
              </option>
            </optgroup>
          </sel>
        </div>
      </div>
    </div>
    <div
      class="user-input-block__note"
      v-show="val.type === 'date' && val.storage === 'context'"
    >
      {{ $t("view.flow.block.input.dateDuplicateVar") }}
      {{ val.name }}FormatedDate
    </div>
    <div
      class="user-input-block__note"
      v-show="val.type === 'time' && val.storage === 'context'"
    >
      {{ $t("view.flow.block.input.dateDuplicateVar") }} {{ val.name }}Original
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      val: null,
    };
  },
  props: ["value", "blockId"],
  created() {
    this.val = this.value;
    this.storageBool = this.value.storage === "database";
  },
  methods: {
    onInput() {
      this.$emit("input", this.val);
      this.$store.commit("SET_FLOW_EDIT_FLAG", [this.blockId, true]);
      this.$store.commit("SET_EDITED", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-input-block {
  @include flowElementShadow();
  width: 45%;
  min-width: 350px;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__memory-data {
    @include alignedFlex(flex-start);
    width: 100%;
  }

  &__input {
    width: 28%;
    margin-right: 15px;

    &--short {
      width: 10%;
      min-width: 65px;
    }

    &--long {
      width: calc(56% + 15px);
    }
  }

  &__label {
    @include labelStyle();
    width: 50%;
  }

  &__textarea {
    margin-top: 4px;
    border: 1px solid $borderGrey;
    border-radius: 4px;
    font-size: 1.1em;
    width: 90%;
    padding: 5px 6px;
    outline: none !important;
    font-weight: 300;
  }

  &__message-data,
  &__regex-data {
    @include alignedFlex(flex-start);
    align-items: flex-start;
    margin-top: 20px;
  }

  &__button-input {
    margin-bottom: 5px;
  }

  &__note {
    font-size: 0.85em;
    font-style: italic;
    margin-top: 10px;
  }
}
</style>
